import { useParams } from 'react-router-dom';
import useSWR from 'swr';

import { generateApiPath, getItem } from '#app/Handler/api';
import ClientEntryPoints from '#app/entrypoints/client';
import { Client } from '#app/typings/client';

type HookReturn = {
  client?: Client;
  loading: boolean;
};

const useClient = (): HookReturn => {
  const { uuid } = useParams<{ uuid: string }>();
  const { data: client, isLoading } = useSWR<Client>(
    generateApiPath(ClientEntryPoints.getItem, { uuid: uuid as string }),
    getItem,
  );

  return {
    client: client,
    loading: isLoading,
  };
};

export default useClient;
